import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import type { AthleticsReadiness } from '@/types/enrollments'

// GET /ajax/athletics/students/{studentAccountId}/readiness (DTA-799 round 2):
// sports physical, emergency card and academic eligibility for one student.
export const athleticsStudentReadiness = async (
  studentAccountId: number
): Promise<AthleticsReadiness> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).get(
    '/ajax/athletics/students/' + studentAccountId + '/readiness'
  )
  const { success: _success, ...data } = response.data
  return Util.Obj.keysToCamel(data) as AthleticsReadiness
}
